import React, { useEffect, useState } from "react";
import { Table, Pagination, Form, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEdit, faTrash, faPlus , faAngleLeft} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useHomeListSectionsQuery, useHomeDeleteSectionMutation } from "../../../../Services/HomeAPI"


function Products() {
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;

    const { data, error, isLoading, refetch } = useHomeListSectionsQuery();
    const [deleteList] = useHomeDeleteSectionMutation();

    console.log("data", data)
    useEffect(() => {
        refetch();
    }, [refetch])

    // Filter data based on search term
    const filteredData = data?.data?.filter((item) =>
        Object.values(item).some((value) =>
            value !== null && value !== undefined && value.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
    );


    // Pagination logic
    const totalPages = Math.ceil(filteredData?.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData?.slice(indexOfFirstItem, indexOfLastItem);

    // Handle page change
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };


    const handleDelete = async (id) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this brand?");
        if (!confirmDelete) return;

        try {
            await deleteList(id).unwrap();  // Call delete API
            alert("Section deleted successfully!");
            refetch();  // Refresh the list after deletion
        } catch (error) {
            console.error("Error deleting banner:", error);
            alert("Failed to delete Section. Please try again.");
        }
    };

    if (isLoading) return <div class="loader"></div>;
    if (error) return <p>Failed to load Data</p>;

    return (
        <div>
            <h3>Sections</h3>
            <div className="breadcrum mb-4">
                <p>
                    <FontAwesomeIcon icon={faAngleLeft} className="mx-2" />   <Link to="/home"><span>Back</span></Link>

                </p>
            </div>
            <div className="content-wrapper">
                <div>
                    {/* Search Input */}
                    <div className="row justify-flex-end search-box">
                        <div className="col-md-6 col-sm-12 col-lg-6 d-flex justify-end gap-10">
                            <InputGroup className="mb-3">
                                <Form.Control
                                    type="text"
                                    placeholder="Search..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </InputGroup>
                            <Link to="/home-section-add"><button className="btn-primary w-100"><FontAwesomeIcon
                                icon={faPlus}
                                className="text-primary mx-2"
                            />Add new</button></Link>
                        </div>

                    </div>


                    {/* Table */}
                    <div className="table-responsive">
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th>Short Description</th>
                                    <th>Product Source</th>
                                    <th>Description</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item.title}</td>
                                        <td>{item.small_heading}</td>
                                        <td>
                                            {item.product_source === "featured"
                                                ? "Featured"
                                                : item.product_source === "best_seller"
                                                    ? "Best Seller"
                                                    : item.product_source === "new_arrivals"
                                                        ? "New Arrivals"
                                                        : item.product_source === "category"
                                                            ? "Category"
                                                            : item.product_source === "featured_category"
                                                                ? "Featured Category"
                                                                : "N/A"}
                                        </td>

                                        <td>{item.description.length > 100 ? item.description.substring(0, 100) + "..." : item.description}</td>

                                        <td>
                                            <Link to={`/home-section-view/${item.id}`}><FontAwesomeIcon
                                                icon={faEye}
                                                className=" mx-2"
                                                style={{ cursor: "pointer" }}
                                            /></Link>
                                            <Link to={`/home-section-edit/${item.id}`}>
                                                <FontAwesomeIcon
                                                    icon={faEdit}
                                                    className="text-warning mx-2"
                                                    style={{ cursor: "pointer" }}
                                                />
                                            </Link>
                                            <FontAwesomeIcon
                                                icon={faTrash}
                                                className="text-danger mx-2"
                                                onClick={() => handleDelete(item.id)}
                                                style={{ cursor: "pointer" }}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>


                    {/* Pagination */}
                    <Pagination className="d-flex justify-flex-end">
                        <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                        <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                        {[...Array(totalPages)].map((_, index) => (
                            <Pagination.Item
                                key={index + 1}
                                active={index + 1 === currentPage}
                                onClick={() => handlePageChange(index + 1)}
                            >
                                {index + 1}
                            </Pagination.Item>
                        ))}
                        <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
                        <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
                    </Pagination>
                </div>
            </div>
        </div>
    );
}

export default Products;
